import { makeVar, ReactiveVar } from "@apollo/client";

export const time: ReactiveVar<string> = makeVar(new Date().toISOString());
